<nav class="navbar navbar-expand-lg bg-white shadow-sm border-bottom px-4 py-2 portal-navigation">
  <div class="d-flex align-items-center">
    <span [class]="'navbar-brand mb-0 fw-bold ' + portalClass">
      <i [class]="'bi me-2 ' + portalIcon"></i>
      {{ portalName }}
    </span>

    @if (firstName || lastName) {
      <span class="portal-welcome ms-3 d-none d-md-inline">
        Welcome back, <strong>{{ firstName }} {{ lastName }}</strong>
      </span>
    }

    @if (activeClinicName) {
      <span
        class="badge bg-primary-subtle text-primary ms-3 d-none d-md-inline-flex align-items-center gap-1"
      >
        <i class="bi bi-hospital"></i> {{ activeClinicName }}
      </span>
    }
  </div>

  <button
    class="navbar-toggler"
    type="button"
    data-bs-toggle="collapse"
    [attr.data-bs-target]="'#' + collapseId"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" [id]="collapseId">
    @if (primaryItems.length) {
      <ul class="navbar-nav ms-lg-4">
        @for (item of primaryItems; track item.route) {
          <li class="nav-item">
            @if (item.disabled) {
              <span
                class="nav-link disabled text-muted"
                title="Not available until practice is active"
              >
                <i class="bi me-1" [class]="item.icon"></i>{{ item.label }}
              </span>
            } @else {
              <a class="nav-link" [routerLink]="item.route" routerLinkActive="active">
                <i class="bi me-1" [class]="item.icon"></i>{{ item.label }}
              </a>
            }
          </li>
        }
      </ul>
    }

    <ul class="navbar-nav ms-auto align-items-center">
      <!-- Switch Practice dropdown — shown only when doctor belongs to > 1 practice -->
      @if (hasMultipleClinics) {
        <li class="nav-item dropdown me-2">
          <a
            class="nav-link dropdown-toggle d-flex align-items-center"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
          >
            <i class="bi bi-building-fill-gear fs-5 me-1 text-success"></i>
            <span class="d-none d-md-inline">Switch Practice</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end shadow-sm">
            <li><h6 class="dropdown-header">My Practices</h6></li>
            @for (clinic of clinicMemberships; track clinic.clinicId) {
              <li>
                <button
                  type="button"
                  class="dropdown-item d-flex align-items-center justify-content-between"
                  [class.active]="clinic.currentlyActive || clinic.clinicId === activeClinicId"
                  (click)="onSwitchClinic(clinic.clinicId)"
                >
                  <span>
                    <i class="bi bi-hospital me-2"></i>{{ clinic.clinicName }}
                    <small class="text-muted d-block ms-4">{{ clinic.city }}</small>
                  </span>
                  @if (clinic.currentlyActive || clinic.clinicId === activeClinicId) {
                    <i class="bi bi-check-circle-fill text-success ms-2"></i>
                  }
                </button>
              </li>
            }
          </ul>
        </li>
      }

      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle d-flex align-items-center"
          href="#"
          role="button"
          data-bs-toggle="dropdown"
        >
          <i class="bi bi-person-circle fs-5 me-2 text-primary"></i>{{ firstName }}
        </a>

        <ul class="dropdown-menu dropdown-menu-end shadow-sm">
          <li>
            <button type="button" class="dropdown-item" (click)="navigate(profileRoute)">
              <i class="bi bi-person me-2 text-primary"></i>My Profile
            </button>
          </li>
          @if (showSettings) {
            <li>
              <button type="button" class="dropdown-item" (click)="navigate(settingsRoute)">
                <i class="bi bi-gear me-2 text-primary"></i>Settings
              </button>
            </li>
          }
          @if (showRoleSwitcher) {
            @for (item of additionalItems; track item.route) {
              <li>
                @if (item.disabled) {
                  <span
                    class="dropdown-item disabled text-muted"
                    title="Not available until practice is active"
                  >
                    <i class="bi me-2" [class]="item.icon"></i>{{ item.label }}
                  </span>
                } @else {
                  <button type="button" class="dropdown-item" (click)="navigate(item.route)">
                    <i class="bi me-2" [class]="item.icon"></i>{{ item.label }}
                  </button>
                }
              </li>
            }
          }
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <button type="button" class="dropdown-item text-danger" (click)="logout()">
              <i class="bi bi-box-arrow-right me-2"></i>Logout
            </button>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>
